import getConfig from 'next/config'
import { useRouter } from 'next/router'
import { useEffect, useRef } from 'react'

const { publicRuntimeConfig } = getConfig()

export function useManageRegisterModal({
  openRegistrationModal,
  lotUniqueId,
  isLoggedIn,
}: {
  openRegistrationModal: () => void
  lotUniqueId: string | number
  isLoggedIn: boolean
}) {
  const { asPath, query } = useRouter()
  const modalOpen = useRef('')

  useEffect(() => {
    if (
      isLoggedIn &&
      query.registerNow &&
      query.registerNow === `${lotUniqueId}` &&
      modalOpen.current !== `${lotUniqueId}`
    ) {
      openRegistrationModal()
      modalOpen.current = query.registerNow

      const { pathname, searchParams } = new URL(
        asPath,
        publicRuntimeConfig.WEB_BASE_URL
      )
      searchParams.delete('registerNow')
      const params = searchParams.toString()

      const newUrl = `${pathname}${params ? `?${params}` : ''}`

      // we use history.replaceState as it's the only way to update the query param without causing a rerender
      window.history.replaceState(
        { ...window.history.state, as: newUrl, url: newUrl },
        '',
        newUrl
      )
    }
  }, [lotUniqueId, asPath, query, openRegistrationModal, isLoggedIn])
}
